import { Component } from 'react';
import { connect } from 'react-redux';

import DisplayedCardContainer from './DisplayedCardContainer';
import FilterPill from '../../customize/components/FilterPill';
import {
  getFilteredRecipes,
  getDishtypes,
  applyRecipeFilters,
  toggleRecipeFilter,
  clearRecipeFilters,
  updateSearchText,
} from '../../customize/actions_creators';
import { sendPageView, deepCloneObj } from '../../utils/utils';

class RecipesRoute extends Component {
  componentDidMount() {
    // sendPageView()
    // if there are recipes in the state don't fetch
    if (!this.props.recipes.length) {
      this.props.getFilteredRecipes();
    }
    // if Customer lands on this page and there are no dishtypes
    if (!this.props.dishtypes.length) {
      this.props.getDishtypes();
    }
  }

  render() {
    let {
      recipes,
      updateSearchText,
      getFilteredRecipes,
      applyRecipeFilters,
      clearRecipeFilters,
      toggleRecipeFilter,
      appliedRecipesFilters,
      canLoadMoreRecipes,
      recipesTotalCount,
      appliedSearchText,
      preCheckout,
      tagOptions,
    } = this.props;

    const clearFunc = () => {
      updateSearchText('');
      clearRecipeFilters();
      getFilteredRecipes();
    };

    if (preCheckout) {
      appliedRecipesFilters = deepCloneObj(appliedRecipesFilters);
      appliedRecipesFilters.featured = [];
    }

    return (
      <div className="recipes-route">
        <FilterPill
          appliedFilters={appliedRecipesFilters}
          toggleFunc={toggleRecipeFilter}
          applyFunc={applyRecipeFilters}
          getFunc={getFilteredRecipes}
          isRecipe={true}
          appliedSearchText={appliedSearchText}
          updateTextFunc={updateSearchText}
          tagOptions={tagOptions}
        />
        <DisplayedCardContainer
          isRecipe={true}
          items={recipes}
          loadMoreFunc={getFilteredRecipes}
          hasMore={canLoadMoreRecipes}
          clearFunc={clearFunc}
          appliedFilters={appliedRecipesFilters}
          totalCount={recipesTotalCount}
          appliedSearchText={appliedSearchText}
        ></DisplayedCardContainer>
      </div>
    );
  }
}

let mapStateToProps = (state) => {
  return {
    preCheckout: !!parseInt(window.preCheckout),
    dishtypes: state.featured.dishtypes,
    recipes: state.filters.recipes,
    selectedDishtype: state.filters.selectedDishType,
    appliedRecipesFilters: state.filters.appliedRecipeFilters,
    canLoadMoreRecipes: state.filters.canLoadMoreRecipes,
    dishTypeCount: state.filters.dishTypeCount,
    recipesTotalCount: state.filters.recipesTotalCount,
    appliedSearchText: state.filters.appliedSearchText,
    tagOptions: state.filters.tagOptions,
  };
};

let mapDispatchToProps = (dispatch) => {
  return {
    getFilteredRecipes: (loadMore) => dispatch(getFilteredRecipes(loadMore)),
    getDishtypes: () => dispatch(getDishtypes()),
    toggleRecipeFilter: (filter, filterCategory) =>
      dispatch(toggleRecipeFilter(filter, filterCategory)),
    applyRecipeFilters: () => dispatch(applyRecipeFilters()),
    clearRecipeFilters: () => dispatch(clearRecipeFilters()),
    updateSearchText: (text) => dispatch(updateSearchText(text)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RecipesRoute);
